import { plural } from '@cian/utils';

import { IOffer } from '../../../types/offer';

export function getRoomTitle(offer: IOffer) {
  return offer.roomsForSaleCount
    ? `${offer.roomsForSaleCount} ${plural(offer.roomsForSaleCount, ['комната', 'комнаты', 'комнат'])}`
    : '1 комната';
}
